import axiosInstance from "../axiosClient";

/**
 * Export maintenance logs to CSV
 * @param {string} token - Auth token
 * @param {string} orgUuid - Organization UUID
 * @param {object} params - Export parameters (startDate, endDate, droneId, maintenanceType)
 * @returns {object} { blob: Blob, filename: string }
 */
export const exportMaintenanceLogsCSV = async (token, orgUuid, params) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.droneId) queryParams.append('droneId', params.droneId);
    if (params.maintenanceType) queryParams.append('maintenanceType', params.maintenanceType);

    const response = await axiosInstance.get(
      `/organization/${orgUuid}/maintenance/export?${queryParams.toString()}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob' // Important for file download
      }
    );

    // Check if response is an error (backend returned JSON instead of CSV)
    if (response.data.type === 'application/json') {
      // Parse the JSON error from blob
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.error || 'Failed to export maintenance logs');
    }

    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'maintenance-logs.csv';


    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    } else {
    }

    return { blob: response.data, filename };
  } catch (error) {

    // If error response is a blob, try to parse it
    if (error.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        const errorData = JSON.parse(text);
        const enhancedError = new Error(errorData.error || 'Failed to export maintenance logs');
        enhancedError.response = error.response;
        throw enhancedError;
      } catch (parseError) {
        // If parsing fails, throw original error
        throw error;
      }
    }

    throw error;
  }
};
